// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Item-module__font-s-10___o5j6r {
  font-size: 10px !important;
}

.Item-module__font-s-12___GO2af {
  font-size: 12px !important;
}

.Item-module__font-s-13___zo5X3 {
  font-size: 13px !important;
}

.Item-module__font-s-14___CKu7o {
  font-size: 14px !important;
}

.Item-module__font-s-15___cVqqM {
  font-size: 15px !important;
}

.Item-module__font-s-16___zUlpw {
  font-size: 16px !important;
}

.Item-module__font-s-18___EaC_Q {
  font-size: 18px !important;
}

.Item-module__font-s-20___jtapo {
  font-size: 20px !important;
}

.Item-module__font-s-22___SYFCj {
  font-size: 22px !important;
}

.Item-module__font-s-28___oiK5N {
  font-size: 28px !important;
}

.Item-module__font-w-400___N5Joz {
  font-weight: 400 !important;
}

.Item-module__font-w-500___bqaxi {
  font-weight: 500 !important;
}

.Item-module__font-w-600___bnnXU {
  font-weight: 600 !important;
}

.Item-module__font-w-700___Qbew2 {
  font-weight: 700 !important;
}

.Item-module__p-5___pLhnU {
  padding: 5px !important;
}

.Item-module__p-12___p0OoE {
  padding: 12px !important;
}

.Item-module__p-16___r9qpU {
  padding: 16px !important;
}

.Item-module__p-30___LKOdI {
  padding: 30px !important;
}

.Item-module__p-b-0___abfoO {
  padding-bottom: 0 !important;
}

.Item-module__p-b-5___wV556 {
  padding-bottom: 5px !important;
}

.Item-module__p-b-10___CHNkG {
  padding-bottom: 10px !important;
}

.Item-module__p-b-12___KkJ0J {
  padding-bottom: 12px !important;
}

.Item-module__p-b-16___NM5Q3 {
  padding-bottom: 16px !important;
}

.Item-module__p-b-18___b9Zr5 {
  padding-bottom: 18px !important;
}

.Item-module__p-b-20___L_g1f {
  padding-bottom: 20px !important;
}

.Item-module__p-b-25___uqNje {
  padding-bottom: 25px !important;
}

.Item-module__p-b-30___VuMXF {
  padding-bottom: 30px !important;
}

.Item-module__p-b-50___tMccm {
  padding-bottom: 50px !important;
}

.Item-module__p-t-0___gFAOn {
  padding-top: 0 !important;
}

.Item-module__p-t-12___Gh3Ws {
  padding-top: 12px !important;
}

.Item-module__p-t-16___Sl_Gn {
  padding-top: 16px !important;
}

.Item-module__p-t-18___Cmqpz {
  padding-top: 18px !important;
}

.Item-module__p-t-20___c2BQ8 {
  padding-top: 20px !important;
}

.Item-module__p-t-30___KzvFK {
  padding-top: 30px !important;
}

.Item-module__p-t-40___ZCmW5 {
  padding-top: 40px !important;
}

.Item-module__p-t-50___mCIEb {
  padding-top: 50px !important;
}

.Item-module__p-l-20___WzWOI {
  padding-left: 20px !important;
}

.Item-module__p-l-30___iXipr {
  padding-left: 30px !important;
}

.Item-module__p-l-40___dN24u {
  padding-left: 40px !important;
}

.Item-module__p-r-16____hjHy {
  padding-right: 16px !important;
}

.Item-module__p-r-20___cT5xo {
  padding-right: 20px !important;
}

.Item-module__p-r-30___Pk7mp {
  padding-right: 30px !important;
}

.Item-module__p-r-50___Exv10 {
  padding-right: 50px !important;
}

.Item-module__p-r-60___XfqvX {
  padding-right: 60px !important;
}

.Item-module__m-b-1___LsG82 {
  margin-bottom: 1px !important;
}

.Item-module__m-b-2___wUxsF {
  margin-bottom: 2px !important;
}

.Item-module__m-b-6___EYqQ9 {
  margin-bottom: 6px !important;
}

.Item-module__m-b-8___EB8AS {
  margin-bottom: 8px !important;
}

.Item-module__m-b-10___m_O1y {
  margin-bottom: 10px !important;
}

.Item-module__m-b-14___RhWyL {
  margin-bottom: 14px !important;
}

.Item-module__m-b-16___aTDtC {
  margin-bottom: 16px !important;
}

.Item-module__m-b-20___tTGkW {
  margin-bottom: 20px !important;
}

.Item-module__m-b-22___mqbOG {
  margin-bottom: 22px !important;
}

.Item-module__m-b-24____d_1R {
  margin-bottom: 24px !important;
}

.Item-module__m-b-30___XrV5D {
  margin-bottom: 30px !important;
}

.Item-module__m-b-32___ay6GM {
  margin-bottom: 32px !important;
}

.Item-module__m-b-40___ZBqlI {
  margin-bottom: 40px !important;
}

.Item-module__m-t-2___na8PH {
  margin-top: 2px !important;
}

.Item-module__m-t-3___fmCVE {
  margin-top: 3px !important;
}

.Item-module__m-t-4___qzEPQ {
  margin-top: 4px !important;
}

.Item-module__m-t-5___F_QKJ {
  margin-top: 5px !important;
}

.Item-module__m-t-8___yilmJ {
  margin-top: 8px !important;
}

.Item-module__m-t-10___g9heI {
  margin-top: 10px !important;
}

.Item-module__m-t-15___Nx2Zt {
  margin-top: 15px !important;
}

.Item-module__m-t-16___Vmz4p {
  margin-top: 16px !important;
}

.Item-module__m-t-20___KBjlW {
  margin-top: 20px !important;
}

.Item-module__m-t-22___ofaU8 {
  margin-top: 22px !important;
}

.Item-module__m-t-30___r5T2r {
  margin-top: 30px !important;
}

.Item-module__m-t-32___hns_m {
  margin-top: 32px !important;
}

.Item-module__m-l-auto___hnDLz {
  margin-left: auto !important;
}

.Item-module__m-l-4___WySKH {
  margin-left: 4px !important;
}

.Item-module__m-l-5___lakqP {
  margin-left: 5px !important;
}

.Item-module__m-l-6___xuki6 {
  margin-left: 6px !important;
}

.Item-module__m-l-8___hBPyA {
  margin-left: 8px !important;
}

.Item-module__m-l-10___OeTat {
  margin-left: 10px !important;
}

.Item-module__m-l-16___FfOY_ {
  margin-left: 16px !important;
}

.Item-module__m-l-20___EO2_r {
  margin-left: 20px !important;
}

.Item-module__m-l-24___Ytbh7 {
  margin-left: 24px !important;
}

.Item-module__m-l-30___ArUDa {
  margin-left: 30px !important;
}

.Item-module__m-l-35___k6jzV {
  margin-left: 35px !important;
}

.Item-module__m-l-40___lBuah {
  margin-left: 40px !important;
}

.Item-module__m-r-8___PiddQ {
  margin-right: 8px !important;
}

.Item-module__m-r-10___aOPPC {
  margin-right: 10px !important;
}

.Item-module__m-r-16___Kxslt {
  margin-right: 16px !important;
}

.Item-module__m-r-20___YQgxf {
  margin-right: 20px !important;
}

.Item-module__m-r-24___KqkDN {
  margin-right: 24px !important;
}

.Item-module__m-r-30___Z9MX6 {
  margin-right: 30px !important;
}

.Item-module__m-r-40___bipTI {
  margin-right: 40px !important;
}

.Item-module__border-r-3___Aw2a6 {
  border-radius: 3px !important;
}

.Item-module__border-r-4___XzziM {
  border-radius: 4px !important;
}

.Item-module__border-r-6___JwDiC {
  border-radius: 6px !important;
}

.Item-module__border-r-10___U9tYH {
  border-radius: 10px !important;
}

.Item-module__border-r-12___U570y {
  border-radius: 12px !important;
}

.Item-module__border-r-16___GeA1J {
  border-radius: 16px !important;
}

.Item-module__border-r-50___Tw_QD {
  border-radius: 50% !important;
}

.Item-module__primary-border___NzpJ8 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-b___zZA7V {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-t___h_19h {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-l___Af243 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-r___hWo8J {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__secondary-border___w1R1K {
  border: 1px solid #637768;
}

.Item-module__secondary-border-b___eTOF5 {
  border-bottom: 1px solid #637768;
}

.Item-module__secondary-border-t___beyTz {
  border-top: 1px solid #637768;
}

.Item-module__secondary-border-l___WzhHp {
  border-left: 1px solid #637768;
}

.Item-module__secondary-border-r___rEf5w {
  border-right: 1px solid #637768;
}

.Item-module__gap-0___imp6f {
  gap: 0 !important;
}

.Item-module__gap-2___b1VKT {
  gap: 2px !important;
}

.Item-module__gap-4___LDFlh {
  gap: 4px !important;
}

.Item-module__gap-5___GJ2Nf {
  gap: 5px !important;
}

.Item-module__gap-6___fPx6t {
  gap: 6px !important;
}

.Item-module__gap-8___IKGO2 {
  gap: 8px !important;
}

.Item-module__gap-10___LgFPB {
  gap: 10px !important;
}

.Item-module__gap-12___qSVW0 {
  gap: 12px !important;
}

.Item-module__gap-14___XkWyC {
  gap: 14px !important;
}

.Item-module__gap-16___GIuYO {
  gap: 16px !important;
}

.Item-module__gap-18___zLPU3 {
  gap: 18px !important;
}

.Item-module__gap-20___skoRH {
  gap: 20px !important;
}

.Item-module__gap-24___JpETQ {
  gap: 24px !important;
}

.Item-module__gap-26___VEvUL {
  gap: 26px !important;
}

.Item-module__gap-30___TKMZJ {
  gap: 30px !important;
}

.Item-module__gap-32___se0lw {
  gap: 32px !important;
}

.Item-module__gap-40___fZ3Ef {
  gap: 40px !important;
}

.Item-module__gap-50___oQj1s {
  gap: 50px !important;
}

.Item-module__flex-1___QFkha {
  flex: 1;
}

.Item-module__flex-none___z16Vt {
  flex: none !important;
}

.Item-module__flex-column___Gu8Ma {
  display: flex;
  flex-direction: column !important;
}

.Item-module__flex-row___KcO6q {
  display: flex;
  flex-direction: row !important;
}

.Item-module__vertically-centered___z8Oky {
  display: flex;
  align-items: center !important;
}

.Item-module__horizontally-centered___t8Fcp {
  display: flex;
  justify-content: center !important;
}

.Item-module__horizontally-end___KsOCy {
  display: flex;
  justify-content: end !important;
}

.Item-module__vertically-start___Kk9wa {
  display: flex;
  align-items: start !important;
}

.Item-module__space-between___mlptB {
  display: flex;
  justify-content: space-between !important;
}

.Item-module__flex-wrap___ldRj2 {
  flex-wrap: wrap !important;
}

.Item-module__height-100___VeXJE {
  height: 100%;
}

.Item-module__width-50___FbVGq {
  width: 50% !important;
}

.Item-module__width-100___mwD4a {
  width: 100%;
}

.Item-module__cursor-pointer___yJKd_ {
  cursor: pointer;
}

.Item-module__cursor-not-allowed___QJ28V {
  cursor: not-allowed !important;
}

.Item-module__absolute-centered___Yh1M_ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Item-module__absolute___bmAop {
  position: absolute;
}

.Item-module__relative___D9luM {
  position: relative;
}

.Item-module__fixed_____9Ce {
  position: fixed;
}

.Item-module__visible___XRGfi {
  opacity: 1;
}

.Item-module__invisible___MOBMp {
  opacity: 0;
}

.Item-module__col-90___wqEEz {
  width: 90% !important;
}

.Item-module__col-auto___P3XjD {
  width: auto !important;
}

.Item-module__medical-tabs___zZOSi {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Item-module__medical-table-new___Bg2ow {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Item-module__medical-table-new___Bg2ow:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Item-module__medical-table-new___Bg2ow::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Item-module__medical-table-new___Bg2ow::-webkit-scrollbar-track {
  display: none;
}
.Item-module__medical-table-new___Bg2ow.Item-module__no-pagination___ulhfp {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Item-module__medical-table-new___Bg2ow.Item-module__no-pagination___ulhfp:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Item-module__medical-table-new___Bg2ow.Item-module__no-pagination___ulhfp::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Item-module__medical-table-new___Bg2ow.Item-module__no-pagination___ulhfp::-webkit-scrollbar-track {
  display: none;
}

.Item-module__medical-table-empty___Exsv7 {
  padding: 14px 40px !important;
}

.Item-module__icon-btn____MkSP {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Item-module__search-icon___RE3wU {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Item-module__disable-select___Sm8ZZ {
  user-select: none;
}

.Item-module__break-word___daRJK {
  word-break: break-word;
}

.Item-module__popup-clear-btn___ItLHW {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Item-module__scroll-m-b-20___g5cPG {
  scroll-margin-bottom: 20px;
}

.Item-module__container___XKaWo {
  display: flex;
  height: 53px;
  color: #375844;
}
.Item-module__container___XKaWo .Item-module__name___ohzQc {
  display: flex;
  flex: 1;
  line-height: 150%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/OrderDetailsPopup/Item/Item.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,YAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,OAAA;EACA,iBAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  height: 53px;\n  color: get-color(greenNew, dark);\n\n  .name {\n    display: flex;\n    flex: 1;\n    line-height: 150%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Item-module__font-s-10___o5j6r`,
	"fontS12": `Item-module__font-s-12___GO2af`,
	"fontS13": `Item-module__font-s-13___zo5X3`,
	"fontS14": `Item-module__font-s-14___CKu7o`,
	"fontS15": `Item-module__font-s-15___cVqqM`,
	"fontS16": `Item-module__font-s-16___zUlpw`,
	"fontS18": `Item-module__font-s-18___EaC_Q`,
	"fontS20": `Item-module__font-s-20___jtapo`,
	"fontS22": `Item-module__font-s-22___SYFCj`,
	"fontS28": `Item-module__font-s-28___oiK5N`,
	"fontW400": `Item-module__font-w-400___N5Joz`,
	"fontW500": `Item-module__font-w-500___bqaxi`,
	"fontW600": `Item-module__font-w-600___bnnXU`,
	"fontW700": `Item-module__font-w-700___Qbew2`,
	"p5": `Item-module__p-5___pLhnU`,
	"p12": `Item-module__p-12___p0OoE`,
	"p16": `Item-module__p-16___r9qpU`,
	"p30": `Item-module__p-30___LKOdI`,
	"pB0": `Item-module__p-b-0___abfoO`,
	"pB5": `Item-module__p-b-5___wV556`,
	"pB10": `Item-module__p-b-10___CHNkG`,
	"pB12": `Item-module__p-b-12___KkJ0J`,
	"pB16": `Item-module__p-b-16___NM5Q3`,
	"pB18": `Item-module__p-b-18___b9Zr5`,
	"pB20": `Item-module__p-b-20___L_g1f`,
	"pB25": `Item-module__p-b-25___uqNje`,
	"pB30": `Item-module__p-b-30___VuMXF`,
	"pB50": `Item-module__p-b-50___tMccm`,
	"pT0": `Item-module__p-t-0___gFAOn`,
	"pT12": `Item-module__p-t-12___Gh3Ws`,
	"pT16": `Item-module__p-t-16___Sl_Gn`,
	"pT18": `Item-module__p-t-18___Cmqpz`,
	"pT20": `Item-module__p-t-20___c2BQ8`,
	"pT30": `Item-module__p-t-30___KzvFK`,
	"pT40": `Item-module__p-t-40___ZCmW5`,
	"pT50": `Item-module__p-t-50___mCIEb`,
	"pL20": `Item-module__p-l-20___WzWOI`,
	"pL30": `Item-module__p-l-30___iXipr`,
	"pL40": `Item-module__p-l-40___dN24u`,
	"pR16": `Item-module__p-r-16____hjHy`,
	"pR20": `Item-module__p-r-20___cT5xo`,
	"pR30": `Item-module__p-r-30___Pk7mp`,
	"pR50": `Item-module__p-r-50___Exv10`,
	"pR60": `Item-module__p-r-60___XfqvX`,
	"mB1": `Item-module__m-b-1___LsG82`,
	"mB2": `Item-module__m-b-2___wUxsF`,
	"mB6": `Item-module__m-b-6___EYqQ9`,
	"mB8": `Item-module__m-b-8___EB8AS`,
	"mB10": `Item-module__m-b-10___m_O1y`,
	"mB14": `Item-module__m-b-14___RhWyL`,
	"mB16": `Item-module__m-b-16___aTDtC`,
	"mB20": `Item-module__m-b-20___tTGkW`,
	"mB22": `Item-module__m-b-22___mqbOG`,
	"mB24": `Item-module__m-b-24____d_1R`,
	"mB30": `Item-module__m-b-30___XrV5D`,
	"mB32": `Item-module__m-b-32___ay6GM`,
	"mB40": `Item-module__m-b-40___ZBqlI`,
	"mT2": `Item-module__m-t-2___na8PH`,
	"mT3": `Item-module__m-t-3___fmCVE`,
	"mT4": `Item-module__m-t-4___qzEPQ`,
	"mT5": `Item-module__m-t-5___F_QKJ`,
	"mT8": `Item-module__m-t-8___yilmJ`,
	"mT10": `Item-module__m-t-10___g9heI`,
	"mT15": `Item-module__m-t-15___Nx2Zt`,
	"mT16": `Item-module__m-t-16___Vmz4p`,
	"mT20": `Item-module__m-t-20___KBjlW`,
	"mT22": `Item-module__m-t-22___ofaU8`,
	"mT30": `Item-module__m-t-30___r5T2r`,
	"mT32": `Item-module__m-t-32___hns_m`,
	"mLAuto": `Item-module__m-l-auto___hnDLz`,
	"mL4": `Item-module__m-l-4___WySKH`,
	"mL5": `Item-module__m-l-5___lakqP`,
	"mL6": `Item-module__m-l-6___xuki6`,
	"mL8": `Item-module__m-l-8___hBPyA`,
	"mL10": `Item-module__m-l-10___OeTat`,
	"mL16": `Item-module__m-l-16___FfOY_`,
	"mL20": `Item-module__m-l-20___EO2_r`,
	"mL24": `Item-module__m-l-24___Ytbh7`,
	"mL30": `Item-module__m-l-30___ArUDa`,
	"mL35": `Item-module__m-l-35___k6jzV`,
	"mL40": `Item-module__m-l-40___lBuah`,
	"mR8": `Item-module__m-r-8___PiddQ`,
	"mR10": `Item-module__m-r-10___aOPPC`,
	"mR16": `Item-module__m-r-16___Kxslt`,
	"mR20": `Item-module__m-r-20___YQgxf`,
	"mR24": `Item-module__m-r-24___KqkDN`,
	"mR30": `Item-module__m-r-30___Z9MX6`,
	"mR40": `Item-module__m-r-40___bipTI`,
	"borderR3": `Item-module__border-r-3___Aw2a6`,
	"borderR4": `Item-module__border-r-4___XzziM`,
	"borderR6": `Item-module__border-r-6___JwDiC`,
	"borderR10": `Item-module__border-r-10___U9tYH`,
	"borderR12": `Item-module__border-r-12___U570y`,
	"borderR16": `Item-module__border-r-16___GeA1J`,
	"borderR50": `Item-module__border-r-50___Tw_QD`,
	"primaryBorder": `Item-module__primary-border___NzpJ8`,
	"primaryBorderB": `Item-module__primary-border-b___zZA7V`,
	"primaryBorderT": `Item-module__primary-border-t___h_19h`,
	"primaryBorderL": `Item-module__primary-border-l___Af243`,
	"primaryBorderR": `Item-module__primary-border-r___hWo8J`,
	"secondaryBorder": `Item-module__secondary-border___w1R1K`,
	"secondaryBorderB": `Item-module__secondary-border-b___eTOF5`,
	"secondaryBorderT": `Item-module__secondary-border-t___beyTz`,
	"secondaryBorderL": `Item-module__secondary-border-l___WzhHp`,
	"secondaryBorderR": `Item-module__secondary-border-r___rEf5w`,
	"gap0": `Item-module__gap-0___imp6f`,
	"gap2": `Item-module__gap-2___b1VKT`,
	"gap4": `Item-module__gap-4___LDFlh`,
	"gap5": `Item-module__gap-5___GJ2Nf`,
	"gap6": `Item-module__gap-6___fPx6t`,
	"gap8": `Item-module__gap-8___IKGO2`,
	"gap10": `Item-module__gap-10___LgFPB`,
	"gap12": `Item-module__gap-12___qSVW0`,
	"gap14": `Item-module__gap-14___XkWyC`,
	"gap16": `Item-module__gap-16___GIuYO`,
	"gap18": `Item-module__gap-18___zLPU3`,
	"gap20": `Item-module__gap-20___skoRH`,
	"gap24": `Item-module__gap-24___JpETQ`,
	"gap26": `Item-module__gap-26___VEvUL`,
	"gap30": `Item-module__gap-30___TKMZJ`,
	"gap32": `Item-module__gap-32___se0lw`,
	"gap40": `Item-module__gap-40___fZ3Ef`,
	"gap50": `Item-module__gap-50___oQj1s`,
	"flex1": `Item-module__flex-1___QFkha`,
	"flexNone": `Item-module__flex-none___z16Vt`,
	"flexColumn": `Item-module__flex-column___Gu8Ma`,
	"flexRow": `Item-module__flex-row___KcO6q`,
	"verticallyCentered": `Item-module__vertically-centered___z8Oky`,
	"horizontallyCentered": `Item-module__horizontally-centered___t8Fcp`,
	"horizontallyEnd": `Item-module__horizontally-end___KsOCy`,
	"verticallyStart": `Item-module__vertically-start___Kk9wa`,
	"spaceBetween": `Item-module__space-between___mlptB`,
	"flexWrap": `Item-module__flex-wrap___ldRj2`,
	"height100": `Item-module__height-100___VeXJE`,
	"width50": `Item-module__width-50___FbVGq`,
	"width100": `Item-module__width-100___mwD4a`,
	"cursorPointer": `Item-module__cursor-pointer___yJKd_`,
	"cursorNotAllowed": `Item-module__cursor-not-allowed___QJ28V`,
	"absoluteCentered": `Item-module__absolute-centered___Yh1M_`,
	"absolute": `Item-module__absolute___bmAop`,
	"relative": `Item-module__relative___D9luM`,
	"fixed": `Item-module__fixed_____9Ce`,
	"visible": `Item-module__visible___XRGfi`,
	"invisible": `Item-module__invisible___MOBMp`,
	"col90": `Item-module__col-90___wqEEz`,
	"colAuto": `Item-module__col-auto___P3XjD`,
	"medicalTabs": `Item-module__medical-tabs___zZOSi`,
	"medicalTableNew": `Item-module__medical-table-new___Bg2ow`,
	"noPagination": `Item-module__no-pagination___ulhfp`,
	"medicalTableEmpty": `Item-module__medical-table-empty___Exsv7`,
	"iconBtn": `Item-module__icon-btn____MkSP`,
	"searchIcon": `Item-module__search-icon___RE3wU`,
	"disableSelect": `Item-module__disable-select___Sm8ZZ`,
	"breakWord": `Item-module__break-word___daRJK`,
	"popupClearBtn": `Item-module__popup-clear-btn___ItLHW`,
	"scrollMB20": `Item-module__scroll-m-b-20___g5cPG`,
	"container": `Item-module__container___XKaWo`,
	"name": `Item-module__name___ohzQc`
};
module.exports = ___CSS_LOADER_EXPORT___;
